import { render, staticRenderFns } from "./ReservaCartao.vue?vue&type=template&id=b0fb6536&scoped=true&"
import script from "./ReservaCartao.vue?vue&type=script&lang=js&"
export * from "./ReservaCartao.vue?vue&type=script&lang=js&"
import style0 from "./ReservaCartao.vue?vue&type=style&index=0&id=b0fb6536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fb6536",
  null
  
)

export default component.exports